export default field => Boolean(field.module_field_id);
